/**
 * ops ダッシュボードの数値メトリクスの表示整形（SLO タブのカード・サービス別表、内訳タブのメンバー別表で共有）。
 * 値が無い（null）ときは「—」、率は「%」付き。集計そのものは ops-core が持ち、ここは文字列化だけを持つ。
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops ダッシュボードの数値（件数 / 工数 / 率 / 土日除外の経過時間）を表示文字列の材料へ整形する。値なしは「—」、率は % 付き、経過は 24 時間未満を時間・以上を SLA と同じ数え方の営業日で出す
 * @graph-connects none
 */

/** 数値メトリクスを表示文字列へ（null は「—」、pct は「%」付き）。 @graph-connects none */
export function formatOpsMetric(value: number | null, pct = false): string {
  if (value === null) return '—';
  return pct ? `${String(value)}%` : String(value);
}

/** 経過の表示単位と値（時間 or 営業日）。 @graph-connects none */
export interface OpsDurationParts {
  /** 表示単位。 */
  unit: 'hours' | 'businessDays';
  /** 単位に合わせた値。 */
  value: number;
}

/**
 * 経過の表示単位を選ぶ。土日除外の時間が 24 時間未満なら時間で（営業日で数えると同日中の返信がすべて 0 に
 * なるため）、それ以上は SLA と同じ数え方の営業日で出す（時間を 24 で割った値ではない）。どちらの値も
 * ops-core の集計（小数 1 桁に丸め済み）をそのまま使う。
 * @graph-connects none
 */
export function opsDurationParts(hours: number, businessDays: number): OpsDurationParts {
  return hours < 24
    ? { unit: 'hours', value: hours }
    : { unit: 'businessDays', value: businessDays };
}
